import {SET_PARK_FEE, SET_PORT_FEE, SET_TAX, SET_TOTALS, SET_TOTALS_EXTRAS} from "../constants/totalConstants";

const defaultTotals = {
    portFee: 0,
    parkFee: 0,
    activitiesAmount: 0,
    roomsAmount: 0,
    subtotal: 0,
    taxes: 0,
    total: 0
};

export const setTotalsReducer = (state = defaultTotals, action) => {
    switch (action.type) {
        case SET_TOTALS:
            return action.payload;
        default:
            return state;
    }
};
export const setTotalsExtrasReducer = (state = defaultTotals, action) => {
    switch (action.type) {
        case SET_TOTALS_EXTRAS:
            return action.payload;
        default:
            return state;
    }
};

export const setParkFeeReducer = (state = {}, action) => {
    switch (action.type) {
        case SET_PARK_FEE:
            return action.payload;
        default:
            return state;
    }
};

export const setPortFeeReducer = (state = {}, action) => {
    switch (action.type) {
        case SET_PORT_FEE:
            return action.payload;
        default:
            return state;
    }
};

export const setTaxReducer = (state = 0, action) => {
    switch (action.type) {
        case SET_TAX:
            return action.payload;
        default:
            return state;
    }
};